export const getTouristTax = (touristTaxes, adults, childrenAges) => {
  if (!touristTaxes || !touristTaxes.length) {
    return null
  }
  let price = 0
  if (adults) {
    touristTaxes.map(tax => {
      price += tax.adults * adults
    })
  }

  if (childrenAges && childrenAges.length) {
    touristTaxes.map(tax => {
      // the under/above columns split at the property's breakpoint (7 for Slovenian
      // eTurizem properties, 12 otherwise) - the backend serializes it per daily row
      // and buckets the booking's children the same way
      const breakpoint = tax.childAgeBreakpoint || 12
      childrenAges.map(age => {
        if (age < breakpoint) {
          price += tax.childrenUnder12
        } else {
          price += tax.childrenAbove12
        }
      })
    })
  }

  return price
}
